import React, { useEffect, useState, useRef } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { cloudStore } from '../firebase';
import { collection, query, where, doc, deleteDoc, getDocs } from 'firebase/firestore';

export function AllMadeWelcome() {
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };
    const [createCollection, setcreateCollection] = useState([])
    // Show create
    useEffect(() => {
        getDocs(query(collection(cloudStore, "welcomeBoard"), where("Post_Content", "!=", null)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                setcreateCollection(data)
            })

        createCollection.sort((a, b) => b["Post_Content"]["date"] - a["Post_Content"]["date"]);
    }, []);

    //Delete comment
    const deleteComment = async (e) => {
        const value = e.target.dataset.value;
        await deleteDoc(doc(cloudStore, "welcomeBoard", value));
    }

    let eachCollection = null
    if (createCollection && Array.isArray(createCollection)) {
        eachCollection = createCollection.map((content) => {
            let pic = content.Post_Content.pic
            let title = content.Post_Content.title
            // let author = content.Post_Content.author
            let boardID = content.Post_Content.boardID

            return (
                <div className="each" key={title}>
                    <div className="each_pic">
                        <img
                            draggable={false}
                            src={pic}
                            alt={title}
                            key={title}
                        />
                    </div>
                    <div>{title}</div>
                    <NavLink to={"/reviseWelcome/" + boardID}>
                        <div
                            className="button profile_explore"
                            onClick={topFunction}
                        >
                            Revise
                        </div>
                    </NavLink>
                    {/* <div
                            className="button profile_explore"
                            onClick={(e) => deleteComment(e)}
                            data-value={boardID}>
                            Delete
                        </div> */}
                </div >
            )
        })
    }


    return (
        <div className='collection_content' style={{ height: "350px", marginTop: "50px" }} >
            <div className='h2bg'>
                <h2>Create WelcomeBoard Post</h2>
            </div>
            <div className="store">
                {eachCollection}
            </div>
        </div>
    );
}